/* Catalogue card effects: the scroll reveal and the pagination progress line. */
(function () {
  if (window.pyCardEffects) return;
  window.pyCardEffects = true;

  /* Reveal: cards rise in as they enter the viewport, staggered within each batch. */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealer = !reduceMotion && 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        var n = 0;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.style.setProperty('--pyb-delay', Math.min(n++, 5) * 0.08 + 's');
          entry.target.classList.add('is-in');
          revealer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -6% 0px' })
    : null;

  function reveal() {
    document.querySelectorAll('.py-catalogue').forEach(function (root) { root.classList.add('py-reveal'); });
    if (!revealer) {
      document.querySelectorAll('.py-catalogue .py-catalogue__item:not(.is-in)').forEach(function (item) { item.classList.add('is-in'); });
      return;
    }
    document.querySelectorAll('.py-catalogue .py-catalogue__item:not(.is-in):not([data-reveal])').forEach(function (item) {
      item.setAttribute('data-reveal', '');
      revealer.observe(item);
    });
  }

  /* Pagination progress: "16 of 56 pieces" and its bar follow the cards actually on the page. */
  function progress() {
    document.querySelectorAll('[data-py-progress]').forEach(function (el) {
      var root = el.closest('.py-catalogue') || document;
      var total = parseInt(el.dataset.total, 10) || 0;
      var shown = Math.min(root.querySelectorAll('.py-catalogue__item').length, total);
      var count = el.querySelector('[data-py-progress-count]');
      var bar = el.querySelector('[data-py-progress-bar]');
      if (!total || !shown) return;
      if (count) count.textContent = shown;
      if (bar) bar.style.width = Math.round(shown / total * 100) + '%';
      el.classList.toggle('is-complete', shown >= total);
    });
  }

  function run() {
    reveal();
    progress();
  }

  run();
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; run(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
